import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useQuestionnaireData } from "../../hooks/useQuestionnaireData";
import { QuestionnaireFormSection } from "../shared/QuestionnaireFormSection";
import { QuestionnaireCheckboxField } from "../shared/QuestionnaireCheckboxField";
import { GtsRodo, JanpolRodo, LargoRodo, SfaRodo } from "./rodo";

export function QuestionnaireRodoSection() {
  const { t } = useTranslation();
  const { questionnaire } = useQuestionnaireData();

  const templateCode = questionnaire.agreement_template_code
    ?.toLowerCase()
    ?.trim();

  const RodoContent = useMemo(() => {
    if (!templateCode) {
      return <GtsRodo />;
    }

    if (templateCode.includes("janpol")) {
      return <JanpolRodo />;
    }
    if (templateCode.includes("sfa")) {
      return <SfaRodo />;
    }
    if (templateCode.includes("largo")) {
      return <LargoRodo />;
    }
    if (templateCode.includes("gts")) {
      return <GtsRodo />;
    }

    return <GtsRodo />;
  }, [templateCode]);

  return (
    <QuestionnaireFormSection>
      <div>{RodoContent}</div>
      <QuestionnaireCheckboxField
        name="rodo_accepted"
        label={t("questionnaires.form.rodo.accepted")}
        required
        isImportant
      />
    </QuestionnaireFormSection>
  );
}
